import type { IconSvgObject } from './types';

const GalleryVerticalEndIcon: IconSvgObject = [
  ["path", { d: "M6 2L18 2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 17L3 15C3 12.643 3 11.4645 3.73223 10.7322C4.46447 10 5.64298 10 8 10H16C18.357 10 19.5355 10 20.2678 10.7322C21 11.4645 21 12.643 21 15V17C21 19.357 21 20.5355 20.2678 21.2678C19.5355 22 18.357 22 16 22L8 22C5.64298 22 4.46447 22 3.73223 21.2678C3 20.5355 3 19.357 3 17Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M4 6L20 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default GalleryVerticalEndIcon;
